import {
    IconDashboard,
    IconFolder,
    IconCalculator,
    IconSettings,
    IconUsers,
    IconBuildingWarehouse,
    IconReportMoney,
    IconAddressBook,
    IconTruck,
    IconUserStar,
    IconFile,
    IconHistory,
    IconCalendarEvent,
    IconChartBar,
    IconChecklist,
    IconLayoutKanban,
    IconDatabaseExport,
    IconTool,
    IconUpload,
} from "@tabler/icons-react"
import { NavGroup } from "../types"

export const sidebarData = {
    user: {
        name: "Admin User",
        email: "admin@mushroom.com",
        avatar: "/avatars/admin.jpg",
    },
    teams: [
        {
            name: "TourOps ERP",
            logo: IconBuildingWarehouse,
            plan: "Mushroom Travel",
        },
    ],
    navGroups: [
        {
            title: "General",
            items: [
                {
                    title: "Dashboard",
                    url: "/dashboard",
                    icon: IconDashboard,
                },
                {
                    title: "My Tasks",
                    url: "/my-tasks",
                    icon: IconChecklist,
                },
                {
                    title: "Task Board",
                    url: "/task-board",
                    icon: IconLayoutKanban,
                },
                {
                    title: "Bookings",
                    url: "/bookings",
                    icon: IconFolder,
                },
                {
                    title: "Companies",
                    url: "/companies",
                    icon: IconAddressBook,
                },
                {
                    title: "Contacts",
                    url: "/contacts",
                    icon: IconUsers,
                },
                {
                    title: "Costing / Estimates",
                    url: "/costing",
                    icon: IconCalculator,
                },
                {
                    title: "Timeline",
                    url: "/timeline",
                    icon: IconCalendarEvent,
                },
                {
                    title: "Reports",
                    url: "/reports",
                    icon: IconChartBar,
                },
            ],
        },
        {
            title: "Management",
            items: [
                {
                    title: "Staff & Guides",
                    url: "/staff",
                    icon: IconUserStar,
                },
                {
                    title: "Suppliers",
                    url: "/suppliers",
                    icon: IconTruck,
                },
                {
                    title: "Documents",
                    url: "/documents",
                    icon: IconFile,
                },
                {
                    title: "Operations",
                    url: "/operations",
                    icon: IconUsers,
                },
                {
                    title: "Finance",
                    url: "/finance",
                    icon: IconReportMoney,
                    items: [
                        {
                            title: "Invoices",
                            url: "/finance",
                        },
                        {
                            title: "Reports",
                            url: "/finance/reports",
                        },
                    ],
                },
            ],
        },
        {
            title: "Admin Settings",
            requiredRole: ["ADMIN", "OP_MANAGER"],
            items: [
                {
                    title: "Users",
                    url: "/users",
                    icon: IconUsers,
                },
                {
                    title: "Activity Log",
                    url: "/activity",
                    icon: IconHistory,
                },
                {
                    title: "Settings",
                    url: "/settings",
                    icon: IconSettings,
                },
                {
                    title: "Database Backup",
                    url: "/tools/backup",
                    icon: IconDatabaseExport,
                },
                {
                    title: "Invoice Simulation",
                    url: "/tools/invoice-simulation",
                    icon: IconTool,
                },
                {
                    title: "WP Import",
                    url: "/tools/wp-import",
                    icon: IconUpload,
                },
            ],
        },
    ] as NavGroup[],
}
